import { useCallback, useEffect } from 'react';

import { useWatch } from 'react-hook-form';

import { AUTOSAVE_DEBOUNCE_TIME } from '../data';
import { UserProfileForm, useUpdateUserProfileMutation } from '../hooks';
import { useUserInfo } from '@/features/users';

export const UpdateDataTrigger = (): null => {
  const form = useWatch() as UserProfileForm;
  const mutation = useUpdateUserProfileMutation();
  const user = useUserInfo();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (
        user.email === form.email &&
        user.twoFactorEnabled === form.twoFactorEnabled
      )
        return;
    }, AUTOSAVE_DEBOUNCE_TIME);

    return () => {
      clearTimeout(timer);
    };
  }, [form]);

  return null;
};
